import { render, staticRenderFns } from "./ReorderHorizontal.vue?vue&type=template&id=25db9043"
import script from "./ReorderHorizontal.vue?vue&type=script&lang=js"
export * from "./ReorderHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports